export default "__VITE_ASSET__B0SD7Pv3__"